export const isLogin = state => {
  return false
}



// WEBPACK FOOTER //
// ./src/store/getters.js